import { Injectable, signal, inject } from '@angular/core';
import { BillingService } from '@generated/services/billing.service';
import { GetCurrentSubscriptionResult } from '@generated/models/get-current-subscription-result';
import { AnalyticsService } from './analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class Subscription {
  private subscriptionResult = signal<GetCurrentSubscriptionResult | null>(null);
  private isLoading = signal(false);
  private analyticsService = inject(AnalyticsService);

  // Public read-only signals
  readonly data = this.subscriptionResult.asReadonly();
  readonly loading = this.isLoading.asReadonly();

  constructor(private billingService: BillingService) {}

  private getBrowserLocale(): string {
    // Get browser locale (e.g., 'en-US', 'ru-RU')
    const browserLocale = navigator.language || 'en-US';
    return browserLocale;
  }

  loadSubscription(): void {
    if (this.isLoading()) return; // Prevent duplicate calls

    this.isLoading.set(true);
    const browserLocale = this.getBrowserLocale();

    this.billingService.apiBillingSubscriptionGet({
      languageLocaleCode: browserLocale
    }).subscribe({
      next: (response) => {
        console.log('Subscription data:', response);
        this.subscriptionResult.set(response);

        // Check if user was just created and send analytics event
        if (response.user_created) {
          console.log('User was just created, sending analytics event');
          this.analyticsService.trackEvent('user_created', {
            language_locale_code: browserLocale
          });
        }

        this.isLoading.set(false);
      },
      error: (error) => {
        console.error('Failed to load subscription:', error);
        this.isLoading.set(false);
      }
    });
  }

  get hasInvoicesRequiringAttention(): boolean {
    return this.subscriptionResult()?.subscription?.has_invoices_requiring_attention || false;
  }
}
